import classNames from 'classnames/bind';

import styles from './S02.module.scss';
import water_product01 from '../../../assets/images/products/barrel/s02/water_product01.png';
import waterHeater_product01 from '../../../assets/images/products/barrel/s02/waterHeater_product01.png';
import bigbottle from '../../../assets/images/products/barrel/s02/bigbottle.png';
import detail_img01 from '../../../assets/images/products/barrel/s02/detail_img01.jpg';
import detail_img02 from '../../../assets/images/products/barrel/s02/detail_img02.jpg';
import detail_img03 from '../../../assets/images/products/barrel/s02/detail_img03.jpg';
import detail_img04 from '../../../assets/images/products/barrel/s02/detail_img04.jpg';
import Products from '../../../components/product/Products';
import Nutrient from '../../../components/product/Nutrient';
import Download from '../../../components/product/Download';

const cx = classNames.bind(styles);

const S02 = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('limiter')}>
        <Products title="제품 소개" products={[{ title: '풀무원샘물 15L', image: water_product01 }]} color="#06542c" />
        <Nutrient
          data={{
            head: ['칼슘(Ca)', '나트륨(Na)', '마그네슘(Mg)', '칼륨(K)', '불소(F)'],
            body: [
              ['포천', '8.6 ~ 13.0', '4.8 ~ 7.4', '1.1 ~ 1.8', '0.6 ~ 1.0', '0.1 ~ 0.3'],
              ['하동', '8.8 ~ 13.4', '2.9 ~ 4.5', '0.9 ~ 1.5', '0.5 ~ 0.9', '0.0 ~ 0.2'],
            ],
          }}
          color="#8dc63e"
          leading
        />
        <Download
          title="풀무원샘물은 안심하고 드실 수 있습니다!"
          names={['수질 성적 검사서(포천)', '수질 성적 검사서(하동)']}
          files={['/static/report/Water_Report-Barrel_15L-Pocheon.pdf', '/static/report/Water_Report-Barrel_15L-Hadong.pdf']}
          color="#06542c"
        />
        <div className={cx('detail')}>
          <h2 className={cx('title')}>대용량 먹는샘물을 신선하고 편리하게</h2>
          <div className={cx('info')}>
            <div className={cx('image')}>
              <img src={bigbottle} alt="" />
            </div>
            <div className={cx('inner')}>
              <ul>
                <li>
                  <img src={detail_img01} alt="" />
                  <div className={cx('content')}>
                    <h3>낙수방지캡</h3>
                    <p>물흘림을 방지하고 유통 과정에서 발생할 수 있는 외부 오염을 차단합니다.</p>
                  </div>
                </li>
                <li>
                  <img src={detail_img02} alt="" />
                  <div className={cx('content')}>
                    <h3>신선캡</h3>
                    <p>공기 중 미생물을 여과하고 외부 공기 유입을 차단하는 신선캡을 적용하여 오염 걱정이 없습니다.</p>
                  </div>
                </li>
                <li>
                  <img src={detail_img03} alt="" />
                  <div className={cx('content')}>
                    <h3>병목랩</h3>
                    <p>병목 부분까지 랩으로 감싸 2차 오염을 방지합니다.</p>
                  </div>
                </li>
                <li>
                  <img src={detail_img04} alt="" />
                  <div className={cx('content')}>
                    <h3>손잡이</h3>
                    <p>편리한 손잡이를 적용해 운반이 쉽고, 병목 접촉을 최소화해 위생성을 높였습니다.</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className={cx('products')}>
          <Products
            title="풀무원샘물 15L 전용 냉온수기"
            products={[
              {
                title: '',
                image: waterHeater_product01,
                price: '250,000원',
                text: '임대시 보증금 : 50,000원\n월 4병 이상 음용 시, 임대료 무료\n약정기간 : 24개월',
                specs: [
                  { label: '제품규격', value: '(W)310×(D)317×(H)1013' },
                  { label: '포장규격', value: '(W)325×(D)340×(H)1060' },
                  { label: '무게', value: '제품 약 15kg, 포장 약 17kg' },
                  { label: '전력', value: '34.07kWh/m' },
                  { label: '출수능력', value: '냉수 2.7L/h, 온수 6.5/h' },
                ],
              },
            ]}
            color="#06542c"
            width="100%"
          />
        </div>
        <div className={cx('precautions')}>
          <h3>※ 유의사항</h3>
          <p>
            약정 기간 만료 전, 임대 해지 시 위약금이 발생할 수 있습니다.
            <br />
            제주도, 울릉도 및 일부 도서/산간 지역은 제품 가격이 상이할 수 있습니다.
            <br />
            냉온수기 조건은 지역에 따라 달라질 수 있습니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default S02;
